import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class ContactAlias extends BaseEntityModel {
  fullName?: string | null;
  id?: number;
  contactId?: number;
  extractedContactId?: number;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  isPrimary?: boolean;

  constructor(model: Partial<ContactAlias> = {}) {
    super(model);

    // Assigned before the name parts so the API applies its full_name mutator first and the
    // parts win when both are sent.
    this.fullName = model.fullName ?? ContactAlias.joinNameParts(model);
    this.id = model.id;
    this.contactId = model.contactId;
    this.extractedContactId = model.extractedContactId;
    this.firstName = model.firstName;
    this.middleName = model.middleName;
    this.lastName = model.lastName;
    this.isPrimary = model.isPrimary;
  }

  private static joinNameParts(model: Partial<ContactAlias>): string | null {
    return !!model.firstName || !!model.lastName
      ? [model.firstName, model.middleName, model.lastName].filter(Boolean).join(' ')
      : null;
  }
}
